// Listas de opções para os dropdowns do formulário de associados

export const SEXO_OPTIONS = [
  { value: 'Masculino', label: 'Masculino' },
  { value: 'Feminino', label: 'Feminino' },
] as const;

export const ESTADO_CIVIL_OPTIONS = [
  { value: 'Solteiro', label: 'Solteiro' },
  { value: 'Casado', label: 'Casado' },
  { value: 'Divorciado', label: 'Divorciado' },
  { value: 'Viúvo', label: 'Viúvo' },
  { value: 'União Estável', label: 'União Estável' },
  { value: 'Separado', label: 'Separado' },
] as const;

export const ORIGEM_OPTIONS = [
  { value: 'Sede', label: 'Sede' },
  { value: 'Teresópolis', label: 'Teresópolis' },
  { value: 'Cabo Frio', label: 'Cabo Frio' },
  { value: 'Engenho de Dentro', label: 'Engenho de Dentro' },
  { value: 'SMT', label: 'SMT' },
] as const;

export const SITUACAO_OPTIONS = [
  { value: 'Associado', label: 'Associado' },
  { value: 'Sócio Aposentado', label: 'Sócio Aposentado' },
  { value: 'Desconhecido', label: 'Desconhecido' },
  { value: 'Particular', label: 'Particular' },
  { value: 'Sócio Usuário', label: 'Sócio Usuário' },
  { value: 'Contribuinte', label: 'Contribuinte' },
  { value: 'Autorizado', label: 'Autorizado' },
  { value: 'Pago no Sindicato', label: 'Pago no Sindicato' },
  { value: 'Funcionário', label: 'Funcionário' },
  { value: 'Carência', label: 'Carência' },
  { value: 'Demitido', label: 'Demitido' },
] as const;

// Lista de países em ordem alfabética (principais países)
export const NACIONALIDADE_OPTIONS = [
  { value: 'Brasil', label: 'Brasil' },
  { value: 'Argentina', label: 'Argentina' },
  { value: 'Bolívia', label: 'Bolívia' },
  { value: 'Chile', label: 'Chile' },
  { value: 'Colômbia', label: 'Colômbia' },
  { value: 'Equador', label: 'Equador' },
  { value: 'Guiana', label: 'Guiana' },
  { value: 'Guiana Francesa', label: 'Guiana Francesa' },
  { value: 'Paraguai', label: 'Paraguai' },
  { value: 'Peru', label: 'Peru' },
  { value: 'Suriname', label: 'Suriname' },
  { value: 'Uruguai', label: 'Uruguai' },
  { value: 'Venezuela', label: 'Venezuela' },
  { value: 'Alemanha', label: 'Alemanha' },
  { value: 'Áustria', label: 'Áustria' },
  { value: 'Bélgica', label: 'Bélgica' },
  { value: 'Dinamarca', label: 'Dinamarca' },
  { value: 'Espanha', label: 'Espanha' },
  { value: 'Finlândia', label: 'Finlândia' },
  { value: 'França', label: 'França' },
  { value: 'Grécia', label: 'Grécia' },
  { value: 'Irlanda', label: 'Irlanda' },
  { value: 'Itália', label: 'Itália' },
  { value: 'Luxemburgo', label: 'Luxemburgo' },
  { value: 'Países Baixos', label: 'Países Baixos' },
  { value: 'Portugal', label: 'Portugal' },
  { value: 'Reino Unido', label: 'Reino Unido' },
  { value: 'Suécia', label: 'Suécia' },
  { value: 'Canadá', label: 'Canadá' },
  { value: 'Estados Unidos', label: 'Estados Unidos' },
  { value: 'México', label: 'México' },
  { value: 'Japão', label: 'Japão' },
  { value: 'China', label: 'China' },
  { value: 'Índia', label: 'Índia' },
  { value: 'Coreia do Sul', label: 'Coreia do Sul' },
  { value: 'Austrália', label: 'Austrália' },
  { value: 'Nova Zelândia', label: 'Nova Zelândia' },
  { value: 'África do Sul', label: 'África do Sul' },
  { value: 'Egito', label: 'Egito' },
  { value: 'Marrocos', label: 'Marrocos' },
  { value: 'Nigéria', label: 'Nigéria' },
  { value: 'Outro', label: 'Outro' },
] as const;
